import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "d-flex align-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_StoreManagementFeeBySection = _resolveComponent("StoreManagementFeeBySection");
    const _component_StoreManagementGoodsPriceSurchargeInfos = _resolveComponent("StoreManagementGoodsPriceSurchargeInfos");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_CoordSelectMap = _resolveComponent("CoordSelectMap");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_Portal = _resolveComponent("Portal");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_MenuButton = _resolveComponent("MenuButton");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_Tabs = _resolveComponent("Tabs");
    const _component_DynamicImportTab = _resolveComponent("DynamicImportTab");
    const _directive_ui_permission = _resolveDirective("ui-permission");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_StoreManagementFeeBySection),
        _createVNode(_component_StoreManagementGoodsPriceSurchargeInfos),
        _createCommentVNode(" 좌표 선택 "),
        _createVNode(_component_InputRow, {
            label: "좌표",
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_text_field, {
                        value: _ctx.formedCoordinate,
                        filled: "",
                        disabled: "",
                        variant: "outlined",
                        dense: "",
                        "hide-details": "auto",
                        class: "grow"
                    }, null, 8 /* PROPS */, ["value"]),
                    _createVNode(_component_CoordSelectMap, {
                        coordinate: _ctx.coordinate,
                        onOnApply: _ctx.setCoordinate
                    }, null, 8 /* PROPS */, ["coordinate", "onOnApply"])
                ])
            ]),
            _: 1 /* STABLE */
        }),
        _createVNode(_component_Portal, { to: "page-title" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" 포탈 타이틀 예시 ")
            ])),
            _: 1 /* STABLE */,
            __: [0]
        }),
        _cache[5] || (_cache[5] = _createElementVNode("h3", null, " 권한에 의한 버튼 숨김 예시 ", -1 /* CACHED */)),
        _createVNode(_component_MenuButton, { items: _ctx.items }, {
            menuName: _withCtx(() => [
                _createVNode(_component_v_icon, { small: "" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode(" mdi-cog-outline ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [1]
                }),
                _cache[2] || (_cache[2] = _createTextVNode(" 그룹설정 "))
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["items"]),
        _createCommentVNode(" computed등으로 추출할지 여부는 개인 판단 "),
        _withDirectives((_openBlock(), _createBlock(_component_v_btn, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" 이 버튼을 보려면 P_GET_TEMPORARY가 있어야 합니다. ")
            ])),
            _: 1 /* STABLE */,
            __: [3]
        })), [
            [_directive_ui_permission, [
                    _ctx.userPermission.P_GET_OTHER_HUB,
                ]]
        ]),
        _createVNode(_component_v_btn, null, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" 조건 없이 보이는 버튼 (일반 상황) ")
            ])),
            _: 1 /* STABLE */,
            __: [4]
        }),
        _cache[6] || (_cache[6] = _createElementVNode("h3", null, " 탭 - 라우트 타입 ", -1 /* CACHED */)),
        _createVNode(_component_Tabs, { tabs: _ctx.tabs }, null, 8 /* PROPS */, ["tabs"]),
        _cache[7] || (_cache[7] = _createElementVNode("h3", null, " 탭 - 다이나믹 임포트 타입 ", -1 /* CACHED */)),
        _createVNode(_component_DynamicImportTab, { tabs: _ctx.dynamicImportTab }, null, 8 /* PROPS */, ["tabs"])
    ]));
}
